// Eine einzige Nav-Badge-Poll-Quelle (offene Vorgänge / ungelesene Mails /
// verpasste Anrufe). Vorher lief `useNavBadges` DOPPELT (NavigationLayout +
// Dashboard-Karte MitteilungszentrumCard) → `GET /telephony/calls` wurde 2×/min
// gepollt. Jetzt läuft der Hook EINMAL im Provider; alle Konsumenten lesen die
// Werte via `useNavBadgesShared()`.
import * as React from "react";
import { createContext, useContext, type ReactNode } from "react";
import { useAuth } from "./AuthContext";
import { useNavBadges, type NavBadges } from "../hooks/useNavBadges";

const Ctx = createContext<NavBadges | undefined>(undefined);

export const NavBadgesProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const badges = useNavBadges(isAuthenticated);
    return <Ctx.Provider value={badges}>{children}</Ctx.Provider>;
};

/** Geteilte Nav-Badge-Zähler (eine Poll-Quelle). Ohne Provider: 0-Werte (kein Poll). */
export const useNavBadgesShared = (): NavBadges => {
    return useContext(Ctx) ?? { vorgaenge: 0, mails: 0, calls: 0 };
};
